import React, { useState, useEffect } from "react";
import { FaPlay, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./VideoCard.css";
const VideoCard = ({ thumbnail, title, vimeoUrl, cat }) => {
  const [isLoading, setIsLoading] = useState(true);
  const titleParts = title.split(",");
  useEffect(() => {
    if (thumbnail) {
      const img = new Image();
      img.src = thumbnail;
      img.onload = () => setIsLoading(false);
      img.onerror = () => setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [thumbnail]);

  /* <div className="video-thumbnail" onClick={handleVideoClick}> */
  return (
    <div className="video-card">
      <Link
        className="video-thumbnail"
        to={`/video/${vimeoUrl.split("/").pop()}`}
      >
        {isLoading && (
          <div className="video-card-loading">
            <div className="spinner"></div>
          </div>
        )}
        <img src={thumbnail || "https://via.placeholder.com/150"} alt={title} />

        <div className="play-button-overlay">
          <FaPlay />
        </div>

        <div className="video-title-overlay">
          <span className="contest-badge">{cat}</span>
          <div className="video-title-text">{titleParts[0]}</div>
        </div>
      </Link>
    </div>
  );
};

export default VideoCard;
